import type { ConversationMessage } from "#types/types.ts";
import { Flex, Text } from "@hopper-ui/components";
import { ReplyIcon } from "@hopper-ui/icons";

interface Props {
    message: ConversationMessage;
}

export const TargetedReplyMessage = ({ message: { content } }: Props) => {
    return (
        <Flex
            padding="inset-sm"
            UNSAFE_marginBottom="-1rem"
            gap="inline-sm"
            marginLeft="auto"
        >
            <ReplyIcon color="neutral-weak" size="sm" />
            <Text
                size="xs"
                color="neutral-weak"
                flexGrow={1}
                className="wai-line-clamp wai-line-clamp-3"
            >
                {content}
            </Text>
        </Flex>
    );
};
